'use client'
import {
  gqlClient
} from "./chunk-6XSQRWIQ.mjs";
import {
  __async,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/tags/listing.ts
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { Exception } from "@wbk/logger";
var getTags = (props) => __async(void 0, null, function* () {
  try {
    const res = yield gqlClient.request(
      gql`
        query getTags($lang: String, $limit: Int, $skip: Int, $where: TagFilter) {
          tagCollection(locale: $lang, limit: $limit, skip: $skip, where: $where) {
            items {
              id
              title
              slug
              order
            }
          }
        }
      `,
      __spreadValues({ order: "order_DESC" }, props)
    );
    return res.tagCollection.items;
  } catch (error) {
    throw new Exception({ error, name: "getTagsException" });
  }
});
var useGetTags = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getTags", props],
    queryFn: () => getTags(props)
  }, options));
};

export {
  useGetTags
};
//# sourceMappingURL=chunk-QNK57P7V.mjs.map